import React from 'react';
import Section from '../ui/Section';

const Method = () => {
  const steps = [
    {
      num: "01",
      title: "Wetterunabhängige Präzision",
      desc: "Die Produktion der Raummodule erfolgt unter strengsten Qualitätskontrollen im Werk. Durch industrielle Prinzipien erzielen wir eine Genauigkeit, die unter freiem Himmel schlicht nicht möglich ist."
    },
    {
      num: "02",
      title: "Bis zu 70 % Zeitersparnis",
      desc: "Während auf dem Grundstück das Fundament entsteht, läuft im Werk bereits die Fertigung. Das verkürzt die Bauzeit massiv und vermeidet monatelange Doppelbelastungen aus Miete und Baufinanzierung."
    },
    {
      num: "03",
      title: "Erprobte Sicherheit",
      desc: "Wir bauen die Zukunft bereits. Mit unserem Systempartner wurden in den letzten 3 Jahren über 10.000 m² Wohnraum realisiert. Erprobt, erweiterbar und standortunabhängig."
    }
  ];

  const comparison = [
    {
      label: "Gesamtbauzeit",
      classic: "mehrere Jahre",
      modular: "Bis zu 70 % Zeitersparnis"
    },
    {
      label: "Wetterrisiko",
      classic: "Hoch (Baustopps möglich)",
      modular: "Durch Hallenfertigung fast ausgeschlossen"
    },
    {
      label: "Qualitätskontrolle",
      classic: "Stichprobenartig, fehleranfällig",
      modular: "Permanente In-Prozess-Kontrolle"
    },
    {
      label: "Fachkräfte",
      classic: "Extremer Mangel vor Ort",
      modular: "Eingespielte Industrieteams"
    },
    {
      label: "Sicherheit",
      classic: "Risiko von Nachträgen",
      modular: "Maximale Termin- & Kostengarantie"
    }
  ];

  return (
    <Section id="method" className="bg-brand-text text-brand-bg border-b border-brand-text/10 dark-selection">
      <div className="mb-20 flex flex-col md:flex-row md:justify-between md:items-end gap-8">
        <h2 className="text-4xl md:text-6xl max-w-2xl leading-[0.9]">
          SYSTEMATISCH GEPLANT.<br />
          <span className="text-brand-bg/70">INDUSTRIELL UMGESETZT.</span>
        </h2>
        <p className="font-mono text-xs uppercase tracking-widest text-brand-bg/80 max-w-xs md:text-right">
          Vorhersehbarkeit in einer unvorhersehbaren Branche.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-brand-bg/30 mb-24">
        {steps.map((step, idx) => (
          <div key={idx} className="group border-r border-b border-brand-bg/30 p-8 md:p-12 hover:bg-brand-bg/10 transition-colors duration-500">
            <div className="font-mono text-3xl mb-12 text-brand-bg/40 group-hover:text-brand-bg transition-colors duration-500">
              {step.num}
            </div>
            <h3 className="text-2xl mb-6">{step.title}</h3>
            <p className="font-inter text-brand-bg/90 leading-relaxed">
              {step.desc}
            </p>
          </div>
        ))}
      </div>

      {/* Comparison Table / Grid */}
      <div>
        <h3 className="font-mono text-sm uppercase tracking-widest text-brand-bg mb-8">
          Systemvergleich im Überblick
        </h3>
        
        <div className="border-t border-brand-bg/50">
          <div className="grid grid-cols-3 gap-4 py-4 border-b border-brand-bg/40 font-mono text-xs uppercase text-brand-bg/90 hidden md:grid">
            <div>Kriterium</div>
            <div>Klassischer Massivbau</div>
            <div className="text-brand-bg font-semibold">51north Systembauweise</div>
          </div>
          
          {comparison.map((item, idx) => (
            <div key={idx} className="py-6 border-b border-brand-bg/40 font-inter md:grid md:grid-cols-3 md:gap-4 md:items-start">
              <div className="font-mono text-xs uppercase text-brand-bg mb-3 md:mb-0 flex items-center">
                {item.label}
              </div>

              {/* Mobile: zwei symmetrische Karten (gestapelt) · Desktop: md:contents löst die Hülle auf */}
              <div className="space-y-3 md:space-y-0 md:contents">
                {/* Klassischer Massivbau — gedämpft */}
                <div className="p-5 rounded border border-brand-bg/15 bg-brand-bg/[0.03] text-brand-bg/60 md:p-0 md:rounded-none md:border-0 md:bg-transparent md:text-brand-bg md:pr-4">
                  <span className="md:hidden font-mono text-[10px] uppercase tracking-widest text-brand-bg/60 block mb-3">
                    − Klassischer Massivbau
                  </span>
                  {item.classic}
                </div>

                {/* 51north Systembauweise — Akzent */}
                <div className="p-5 rounded border border-brand-bg/55 bg-brand-bg/[0.14] text-brand-bg font-bold md:p-0 md:rounded-none md:border-0 md:bg-transparent">
                  <span className="md:hidden font-mono text-[10px] uppercase tracking-widest text-brand-bg/70 block mb-3 font-normal">
                    + 51north Systembauweise
                  </span>
                  {item.modular}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Method;